import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"


const __default__ = {
  name: 'ICMMenuSubmenu',
};

import type { QMenuProps } from 'quasar/dist/types';
import QMenu from 'quasar/src/components/menu/QMenu.js';;
import { ref } from 'vue';
import { ICMEventHub, exapndItem } from '../utils';
import type { ICMMenuExpandedComponent } from '../types';

/* Types Start */
interface propsType extends QMenuProps {
  activeIds: Array<number>;
  disabled?: boolean | undefined;
  activeClass?: string | undefined;
  rootClass?: string;
  active: Set<number>;
  label?: string;
  portal?: boolean | undefined;
}

/* Types End */

/* Component Basic Start */

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    activeIds: null,
    disabled: { type: [Boolean, null] },
    activeClass: null,
    rootClass: null,
    active: null,
    label: null,
    portal: { type: [Boolean, null] }
  },
  setup(__props: any, { expose }) {

const props = __props as {
  activeIds: Array<number>;
  disabled?: boolean | undefined;
  activeClass?: string | undefined;
  rootClass?: string;
  active: Set<number>;
  label?: string;
  portal?: boolean | undefined;
}

const $this = ref<ICMMenuExpandedComponent>();
const $refSubmenu = ref<QMenu | undefined>();

/* Component Basic End */
/* Data Start */
const hasHover = ref<boolean>(false);
const id = ICMEventHub.getId();
/* Data End */

/* Fucntions Start */
const handleMousehover = (): void => {
  hasHover.value = true;
  if (!props.disabled) exapndItem($this.value);
};
const handleMouseleave = (): void => {
  hasHover.value = false;
  if (!props.disabled) ICMEventHub.$emit('submenuMouseleave');
};

const updatePosition = (): void => {
  ($refSubmenu.value as QMenu).updatePosition();
};
/* Fucntions End */

expose({
  updatePosition,
  id,
});

return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, {
    ref_key: "$this",
    ref: $this,
    active: __props.active.has(_unref(id)),
    clickable: false,
    "active-class": __props.activeClass,
    disable: __props.disabled || undefined,
    dense: "",
    class: _normalizeClass(["q-px-sm ICMMenu-q-item", { 'ICMMenu-q--disabled': __props.disabled }]),
    style: {"white-space":"nowrap"},
    onMouseleave: handleMouseleave,
    onMouseenter: handleMousehover,
    onClick: _cache[0] || (_cache[0] = () => (!__props.active.has(_unref(id)) ? _unref(ICMEventHub).$emit('submenuClick', [...__props.activeIds, _unref(id)]) : null))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["row inline full-width", { 'ICMMenu-q-submenu-item-has-hover': hasHover.value }])
      }, [
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.label), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_q_item_section, {
          class: "ICMMenu-q-submenu-item-prepend",
          side: ""
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "prepend")
          ]),
          _: 3
        }),
        _createVNode(_component_q_item_section, {
          side: "",
          style: _normalizeStyle({ padding: _ctx.$slots.prepend ? 0 : undefined })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: "keyboard_arrow_right",
              style: {"margin-top":"1px"},
              class: _normalizeClass({ 'ICMMenu-q-submenu-item-disabled': __props.disabled })
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 8, ["style"]),
        _createVNode(_unref(QMenu), _mergeProps({
          ref_key: "$refSubmenu",
          ref: $refSubmenu
        }, _ctx.$attrs, {
          disabled: __props.disabled || undefined,
          persistent: hasHover.value || !!_ctx.$attrs.persistent,
          "model-value": __props.active.has(_unref(id)),
          offset: [18, 0],
          "transition-duration": 50
        }), {
          default: _withCtx(() => [
            (__props.portal)
              ? _renderSlot(_ctx.$slots, "default", { key: 0 })
              : (_openBlock(), _createBlock(_component_q_list, {
                  key: 1,
                  class: _normalizeClass(`${__props.rootClass || ''} q-ma-sm`),
                  dense: ""
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default", {
                      subBind: { activeIds: [...__props.activeIds, _unref(id)] }
                    })
                  ]),
                  _: 3
                }, 8, ["class"]))
          ]),
          _: 3
        }, 16, ["disabled", "persistent", "model-value"])
      ], 2)
    ]),
    _: 3
  }, 8, ["active", "active-class", "disable", "class"]))
}
}

})